import { useMutation, useQueryClient } from "@tanstack/react-query";
import studentApi from "../../api/studentApi";
type UpdateStudentPayload = {
    id: number;
    data: {
        fullName: string,
        gender: string,
        dateOfBirth: string,
        email: string,
        phoneNumber: string,
        address: string,
        status: string,
        schoolGrade: string,
    }
};

export const useUpdateStudent = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: UpdateStudentPayload) =>
            studentApi.updateProfileStudent(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["users"],
            });
        },
    });
};

